import React, {FC} from 'react';
import {Link} from "react-router-dom";

interface Props {
    item: any;
}

const FooterComponent: FC<Props> = ({
    item,
                                    }) => {
    return (
        <>
            {item.email && item.phone && item.address &&
                <div className={'contacts'}>
                    <div>
                        <p className={'decorP'}>
                            <a href={'mailto:' + item.email}>
                                <img src={process.env.PUBLIC_URL + item.emailIcon} alt={'email'}/>
                                {item.email}
                            </a>
                        </p>
                        <p className={'decorP'}>
                            <a href={'tel:' + item.phone.replaceAll(" ", "")}>
                                <img src={process.env.PUBLIC_URL + item.phoneIcon} alt={'phone'}/>
                                {item.phone}
                            </a>
                        </p>
                    </div>
                    <p className={'decorP'}>
                        <img src={process.env.PUBLIC_URL + item.addressIcon} alt={'address'}/>
                        {item.address}
                    </p>

                    <a
                        className={'wh'}
                        href={`https://wa.me/` + item.phone.replaceAll(' ', '').split('+')[1]}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            position: 'fixed',
                            bottom: '3rem',
                            right: '3rem',
                            zIndex: 1000
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/img/whatsapp.svg'}
                            alt="WhatsApp"
                            width="60"
                            height="60"
                        />
                    </a>
                </div>
            }
            {item.copyright && <p className={'copyright'}>Copyright 2005
                - {new Date().getFullYear()} - {item.copyright} <br/> <br/><Link to={'/policy.html'}>Privacy Policy</Link></p>}
        </>
    );
};

export default FooterComponent;